export enum ShadowSizes {
	None = '',
	Small = 'small',
	Normal = 'normal',
	Large = 'large',
}
